import React, { useEffect, useMemo, useState } from "react";
import styles from "./Home.module.scss";
import { useTranslation } from "react-i18next";
import axios from "axios";
import {
  Drawer,
  FormControlLabel,
  styled,
  Switch,
  Box,
  TextField,
  Button,
} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import i18n from "../../i18n/config";
import Table from "../../components/Table";
import { Link } from "react-router-dom";
import AddAccountDrawer from "../../components/AddAccountDrawer";
import CircularProgress from "@mui/material/CircularProgress";
import { StayCurrentLandscapeSharp } from "@mui/icons-material";
import Withdrawal from "../Withdrawal/Withdrawal";
import Deposit from "../Deposit/Deposit";
export default function Home({
  theme,
  usdToEur,
  eurToUsd,
  account,
  setAccount,
  balance,
  setBalance,
  margin,
  setMargin,
  accounts,
  setSnackMessage,
  setSnackType,
  applications,
  handleClick,
  getSymbolByAccount,
  AccountTypeEnum,
  totalBalanceDemo,
  getAssetNameByAccount
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [chatHistory, setChatHistory] = useState([]);

  const toggleChat = () => setIsChatOpen((prev) => !prev);

  const sendMessage = () => {
    if (message.trim()) {
      setChatHistory((prev) => [...prev, { sender: "User", text: message }]);
      setMessage("");

      // Симуляция ответа оператора
      setTimeout(() => {
        setChatHistory((prev) => [
          ...prev,
          { sender: "Operator", text: "Спасибо за ваше сообщение!" },
        ]);
      }, 1000);
    }
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const [drawerWithdrawalIsOpen, setDrawerWithdrawal] = useState(false);
  const handleSetDrawerWithdrawal = () => {
    setDrawerWithdrawal(!drawerWithdrawalIsOpen);
  };

  const [drawerDepositIsOpen, setDrawerDeposit] = useState(false);
  const handleSetDrawerDeposit = () => {
    setDrawerDeposit(!drawerDepositIsOpen);
  };

  const type = "real";

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(() => ({
    width: 32,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",

        "& .MuiSwitch-thumb": {
          backgroundColor: "#fcfcfc",
        },
        "& + .MuiSwitch-track": {
          backgroundColor: "#a855f7",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#fcfcfc",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme === "dark" ? "#3F3F46" : "#FCFCFD",
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme === "dark" ? 0.3 : 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
      backgroundColor: theme === "dark" ? "#3F3F46" : "#FCFCFD",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme === "dark" ? "#131316" : "#D1D5DB",
      opacity: 1,
      transition: "all 0.15s ease-in-out",
    },
  }));

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_test_url}/api/transactions/crm/${account?.Id}`,
        {
          headers: {
            Authorization: "Bearer " + secureLocalStorage.getItem("token"),
          },
        }
      )
      .then((result) => {
        const deposits = result.data?.deposits || [];
        const withdrawals = result.data?.withdrawals || [];
        const allTransactions = [...deposits, ...withdrawals];

        allTransactions.sort((a, b) => new Date(b.Date) - new Date(a.Date));

        setTransactions(
          Array.from(result.data?.deposits).concat(result.data?.withdrawals)
        );
      })
      .catch((e) => console.log(e));
  }, [account]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "Date",
        header: t("Date"),
        size: 160,
        grow: 1,
        Header: ({ column }) => (
          <div
            className={styles.header_cell}
            onClick={() => column.getToggleSortingHandler()}
          >
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Date")}
            </span>
            <div className={styles.sort_icon}>
              {column.getIsSorted() === "asc" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="0.8vh"
                  height="0.5vh"
                  viewBox="0 0 8 5"
                  fill="none"
                >
                  <path
                    d="M1 4L4 1L7 4"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : column.getIsSorted() === "desc" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="0.8vh"
                  height="0.5vh"
                  viewBox="0 0 8 5"
                  fill="none"
                >
                  <path
                    d="M7 1L4 4L1 1"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0.8vh"
                    height="0.5vh"
                    viewBox="0 0 8 5"
                    fill="none"
                  >
                    <path
                      d="M1 4L4 1L7 4"
                      stroke="#9CA3AF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0.8vh"
                    height="0.5vh"
                    viewBox="0 0 8 5"
                    fill="none"
                  >
                    <path
                      d="M7 1L4 4L1 1"
                      stroke="#9CA3AF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </>
              )}
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {moment.utc(row.original.Date).local().format("YYYY-MM-DD HH:mm")}
            </span>
          );
        },
      },
      {
        accessorKey: t("Type"),
        header: t("Type"),
        size: 70,
        grow: 1,
        Header: ({ column }) => (
          <div
            className={styles.header_cell}
            onClick={() => column.getToggleSortingHandler()}
          >
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Type")}
            </span>
            <div className={styles.sort_icon}>
              {column.getIsSorted() === "asc" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="0.8vh"
                  height="0.5vh"
                  viewBox="0 0 8 5"
                  fill="none"
                >
                  <path
                    d="M1 4L4 1L7 4"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : column.getIsSorted() === "desc" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="0.8vh"
                  height="0.5vh"
                  viewBox="0 0 8 5"
                  fill="none"
                >
                  <path
                    d="M7 1L4 4L1 1"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0.8vh"
                    height="0.5vh"
                    viewBox="0 0 8 5"
                    fill="none"
                  >
                    <path
                      d="M1 4L4 1L7 4"
                      stroke="#9CA3AF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0.8vh"
                    height="0.5vh"
                    viewBox="0 0 8 5"
                    fill="none"
                  >
                    <path
                      d="M7 1L4 4L1 1"
                      stroke="#9CA3AF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </>
              )}
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span
              style={
                row.original.Type === "Deposit"
                  ? {
                      color: "#00B4A0",
                      borderRadius: "9999px",
                      padding: "0.4vh 0.8vh",
                      width: "max-content",
                      background: "rgba(0, 180, 160, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "0.8vh",
                    }
                  : {
                      color: "#E9770E",
                      borderRadius: "9999px",
                      padding: "0.4vh 0.8vh",
                      width: "max-content",
                      background: "rgba(233, 119, 14, 0.08)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "0.8vh",
                    }
              }
            >
              {row.original.Type === "Deposit" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"1.7vh"}
                  height={"1.6vh"}
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M13.3812 13.3335V9.3335M13.3812 9.3335L14.7145 10.6668M13.3812 9.3335L12.0479 10.6668"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.3809 7.99984C15.3809 5.48568 15.3809 4.2286 14.5999 3.44755C13.8188 2.6665 12.5618 2.6665 10.0476 2.6665H7.38094C4.86678 2.6665 3.6097 2.6665 2.82866 3.44755C2.04761 4.2286 2.04761 5.48568 2.04761 7.99984C2.04761 10.514 2.04761 11.7711 2.82866 12.5521C3.6097 13.3332 4.86678 13.3332 7.38094 13.3332H10.0476"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M7.38102 10.6665H4.71436"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9.38119 10.6665H9.04785"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2.04761 6.6665L15.3809 6.6665"
                    stroke="#00B4A0"
                    strokeLinecap="round"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"1.7vh"}
                  height={"1.6vh"}
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M13.3812 9.3335V13.3335M13.3812 13.3335L14.7145 12.0002M13.3812 13.3335L12.0479 12.0002"
                    stroke="#E9770E"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.3809 7.99984C15.3809 5.48568 15.3809 4.2286 14.5999 3.44755C13.8188 2.6665 12.5618 2.6665 10.0476 2.6665H7.38094C4.86678 2.6665 3.6097 2.6665 2.82866 3.44755C2.04761 4.2286 2.04761 5.48568 2.04761 7.99984C2.04761 10.514 2.04761 11.7711 2.82866 12.5521C3.6097 13.3332 4.86678 13.3332 7.38094 13.3332H10.0476"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M7.38102 10.6665H4.71436"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M9.38119 10.6665H9.04785"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2.04761 6.6665L15.3809 6.6665"
                    stroke="#E9770E"
                    strokeLinecap="round"
                  />
                </svg>
              )}
              {t(row.original.Type)}
            </span>
          );
        },
      },
      {
        accessorKey: "Sum",
        header: t("Amount"),
        size: 110,
        grow: 1,
        Header: ({ column }) => (
          <div
            className={styles.header_cell}
            onClick={() => column.getToggleSortingHandler()}
          >
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Amount")}
            </span>
            <div className={styles.sort_icon}>
              {column.getIsSorted() === "asc" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="0.8vh"
                  height="0.5vh"
                  viewBox="0 0 8 5"
                  fill="none"
                >
                  <path
                    d="M1 4L4 1L7 4"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : column.getIsSorted() === "desc" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="0.8vh"
                  height="0.5vh"
                  viewBox="0 0 8 5"
                  fill="none"
                >
                  <path
                    d="M7 1L4 4L1 1"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0.8vh"
                    height="0.5vh"
                    viewBox="0 0 8 5"
                    fill="none"
                  >
                    <path
                      d="M1 4L4 1L7 4"
                      stroke="#9CA3AF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="0.8vh"
                    height="0.5vh"
                    viewBox="0 0 8 5"
                    fill="none"
                  >
                    <path
                      d="M7 1L4 4L1 1"
                      stroke="#9CA3AF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </>
              )}
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          return (
            <span>
              {getSymbolByAccount()}{" "}
              {parseFloat(
                row.original.Sum *
                  (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              ).toFixed(2)}
            </span>
          );
        },
      },
      {
        accessorKey: "Status",
        header: t("Status"),
        size: 100,
        grow: 1,
        Header: () => (
          <div className={styles.header_cell}>
            <span
              style={{ fontWeight: "500", lineHeight: "1.6vh" }}
              className={styles.header_name}
            >
              {t("Status")}
            </span>
            <div className={styles.sort_icon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M1 4L4 1L7 4"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"0.8vh"}
                height={"0.5vh"}
                viewBox="0 0 8 5"
                fill="none"
              >
                <path
                  d="M7 1L4 4L1 1"
                  stroke="#9CA3AF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ),
        Cell: ({ row }) => {
          const status = row.original?.ApplicationId
            ? ["Submitted", "Expectation"].includes(row.original?.Status)
              ? "Pending"
              : "Completed"
            : "Completed";
          return (
            <span
              style={{
                color: "#52A5E5",
                padding: "4px 8px",
                borderRadius: "9999px",
                fontSize: "1.2vh",
                background: "rgba(82, 165, 229, 0.08)",
              }}
            >
              {status}
            </span>
          );
        },
      },
    ],
    [i18n.language, transactions, account]
  );
  // console.log(transactions);
  return (
    <div className={styles.home}>
      <div className={styles.home_title}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.67939 5.21532C1.33325 5.84768 1.33325 6.61049 1.33325 8.13611V9.15013C1.33325 11.7507 1.33325 13.051 2.1143 13.8589C2.89535 14.6668 4.15243 14.6668 6.66658 14.6668H9.33325C11.8474 14.6668 13.1045 14.6668 13.8855 13.8589C14.6666 13.051 14.6666 11.7507 14.6666 9.15013V8.13611C14.6666 6.61049 14.6666 5.84768 14.3205 5.21532C13.9743 4.58297 13.342 4.1905 12.0772 3.40558L10.7439 2.57808C9.40699 1.74836 8.73854 1.3335 7.99992 1.3335C7.26129 1.3335 6.59284 1.74836 5.25594 2.57808L3.92261 3.40558C2.65788 4.19051 2.02552 4.58297 1.67939 5.21532ZM5.99992 11.5002C5.72378 11.5002 5.49992 11.724 5.49992 12.0002C5.49992 12.2763 5.72378 12.5002 5.99992 12.5002H9.99992C10.2761 12.5002 10.4999 12.2763 10.4999 12.0002C10.4999 11.724 10.2761 11.5002 9.99992 11.5002H5.99992Z"
            fill="#FCFCFC"
          />
        </svg>
        {t("Home")}
      </div>
      <div className={styles.home_body}>
        <div className={styles.info_accounts}>
          <div className={styles.info}>
            <div className={styles.info_title}>
              <div className={styles.name_email}>
                <p>
                  {secureLocalStorage.getItem("user")?.FirstName}{" "}
                  {secureLocalStorage.getItem("user")?.LastName}
                </p>
                <span>{secureLocalStorage.getItem("user")?.Login}</span>
              </div>
              <div className={styles.id}>
                <div>
                  ID: <span>{account?.Id}</span>
                </div>
                {
                  account?.AccountType === AccountTypeEnum.Fake
                  ?<span className={styles.demo_account}>Demo</span>:''
                }
              </div>
            </div>
            <div className={styles.info_body}>
              <div className={styles.balance_block}>
                {account?.AccountType === AccountTypeEnum.Fake?
                    <div className={styles.balance}>
                        <span>{t("Total demo balance")}</span>
                        <h1>
                          {totalBalanceDemo?  account?.AccountCurrency == "EUR"?(totalBalanceDemo * eurToUsd).toFixed(2) :totalBalanceDemo.toFixed(2) :0} 
                          {' '}
                          {secureLocalStorage.getItem('selected_account')?.AccountCurrency === 'EUR'?'EUR':'USD'}
                        </h1>
                    </div>
                    :
                <div className={styles.balance}>
                  <span>{t("Total Balance")}:</span>
                  <h1 style={{ zIndex: 2 }}>
                    {applications?.balances
                      ? Math.trunc(
                          (balance +
                            applications?.balances?.reduce(
                              (sum, val) => (sum += val?.TotalSum),
                              0
                            )) *
                            (account?.AccountCurrency === "EUR"
                              ? eurToUsd
                              : 1) *
                            100
                        ) / 100
                      : Math.trunc(
                          balance *
                            (account?.AccountCurrency === "EUR"
                              ? eurToUsd
                              : 1) *
                            100
                        ) / 100}
                    {account?.AccountCurrency === "EUR" ? "EUR" : "USD"}
                  </h1>
                </div>
                }
                <div className={styles.select}></div>
              </div>
              <div className={styles.free_balance_block}>
                <div className={styles.balance}>
                  <span>{t("Free Balance")}:</span>
                  {account?.AccountCurrency === "EUR" ? (
                    <h1 style={{ zIndex: 2 }}>
                      {parseFloat(
                        account?.AccountBalance * eurToUsd +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            eurToUsd
                      ) ||
                      parseFloat(
                        account?.AccountBalance * eurToUsd +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            eurToUsd
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance * eurToUsd +
                            (applications?.balances?.find(
                              (val) => val?.PlatformId == account?.Id
                            )?.TotalSum
                              ? applications?.balances?.find(
                                  (val) => val?.PlatformId == account?.Id
                                )?.TotalSum
                              : 0) *
                              eurToUsd) *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" EUR "}/{" "}
                      {parseFloat(
                        account?.AccountBalance * 1 +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            1
                      ) ||
                      parseFloat(
                        account?.AccountBalance * 1 +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            1
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance * 1 +
                            (applications?.balances?.find(
                              (val) => val?.PlatformId == account?.Id
                            )?.TotalSum
                              ? applications?.balances?.find(
                                  (val) => val?.PlatformId == account?.Id
                                )?.TotalSum
                              : 0) *
                              1) *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" USD "}
                    </h1>
                  ) : (
                    <h1 style={{ zIndex: 2 }}>
                      {parseFloat(
                        account?.AccountBalance * 1 +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            1
                      ) ||
                      parseFloat(
                        account?.AccountBalance * 1 +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            1
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance * 1 +
                            (applications?.balances?.find(
                              (val) => val?.PlatformId == account?.Id
                            )?.TotalSum
                              ? applications?.balances?.find(
                                  (val) => val?.PlatformId == account?.Id
                                )?.TotalSum
                              : 0) *
                              1) *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" USD "}/{" "}
                      {parseFloat(
                        account?.AccountBalance * eurToUsd +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            eurToUsd
                      ) ||
                      parseFloat(
                        account?.AccountBalance * eurToUsd +
                          (applications?.balances?.find(
                            (val) => val?.PlatformId == account?.Id
                          )?.TotalSum
                            ? applications?.balances?.find(
                                (val) => val?.PlatformId == account?.Id
                              )?.TotalSum
                            : 0) *
                            eurToUsd
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance * eurToUsd +
                            (applications?.balances?.find(
                              (val) => val?.PlatformId == account?.Id
                            )?.TotalSum
                              ? applications?.balances?.find(
                                  (val) => val?.PlatformId == account?.Id
                                )?.TotalSum
                              : 0) *
                              eurToUsd) *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" EUR "}
                    </h1>
                  )}
                </div>
                <div className={styles.select}></div>
              </div>
              <div className={styles.currency_block}>
                <div className={styles.free_balance}>
                  <span>{t("Balance by wallet")}:</span>
                  {account?.AccountCurrency === "EUR" ? (
                    <h1 style={{ zIndex: 2 }}>
                      {parseFloat(
                        (account?.AccountBalance + account?.Margin) * eurToUsd
                      ) ||
                      parseFloat(
                        (account?.AccountBalance + account?.Margin) * eurToUsd
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance + account?.Margin) *
                            eurToUsd *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" EUR "}/{" "}
                      {parseFloat(
                        (account?.AccountBalance + account?.Margin)
                      ) ||
                      parseFloat(
                        (account?.AccountBalance + account?.Margin)
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance + account?.Margin) *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" USD"}
                    </h1>
                  ) : (
                    <h1 style={{ zIndex: 2 }}>
                      
                      {parseFloat(
                        (account?.AccountBalance + account?.Margin)
                      ) ||
                      parseFloat(
                        (account?.AccountBalance + account?.Margin)
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance + account?.Margin) *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" USD "}/{" "}
                      
                      {parseFloat(
                        (account?.AccountBalance + account?.Margin) * eurToUsd
                      ) ||
                      parseFloat(
                        (account?.AccountBalance + account?.Margin) * eurToUsd
                      ) === 0 ? (
                        Math.trunc(
                          (account?.AccountBalance + account?.Margin) *
                            eurToUsd *
                            100
                        ) / 100
                      ) : (
                        <CircularProgress size="30px" />
                      )}
                      {" EUR"}
                    </h1>
                  )}
                </div>
                <div className={styles.select}></div>
              </div>
              <span className={styles.bg_chart}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"40.4vh"}
                  height={"19.3vh"}
                  viewBox="0 0 404 193"
                  fill="none"
                >
                  <path
                    d="M0 162.071L2.6473 154.36C2.92804 153.542 3.74302 153.033 4.60116 153.138V153.138C5.54227 153.254 6.41598 152.632 6.61386 151.705L7.6682 146.764C8.10611 144.711 11.0059 144.633 11.5546 146.658L11.9588 148.15C12.2652 149.281 13.4739 149.908 14.5747 149.506L15.347 149.224C15.5525 149.149 15.769 149.109 15.9877 149.104L17.3392 149.073C18.2058 149.054 18.9862 149.595 19.2721 150.413L19.7263 151.713C20.3804 153.586 23.0672 153.467 23.5534 151.544L25.0568 145.599L26.9237 134.891C27.2737 132.883 30.0508 132.624 30.7666 134.532L31.3147 135.993L33.1029 141.632C33.5908 143.171 35.705 143.33 36.4178 141.882L36.7048 141.299C37.1246 140.446 38.2717 140.283 38.912 140.986V140.986C39.6577 141.805 41.0179 141.426 41.2323 140.339L43.5353 128.667C43.7135 127.764 44.5128 127.118 45.4332 127.134V127.134C46.3334 127.149 47.0997 127.793 47.2692 128.678L48.6724 136.002C48.981 137.613 51.2834 137.622 51.6056 136.014V136.014C51.9331 134.38 54.286 134.427 54.547 136.074L55.2598 140.57C55.5759 142.565 58.3122 142.887 59.0835 141.021L59.4177 140.212C59.4769 140.069 59.5192 139.92 59.5438 139.767L62.5631 121.042C62.6109 120.746 62.7247 120.464 62.8961 120.218L65.6441 116.27C65.7243 116.154 65.7921 116.031 65.8465 115.902L67.991 110.797C68.3682 109.899 69.6062 109.81 70.1073 110.646V110.646C70.7037 111.64 72.2248 111.28 72.313 110.124L74.3236 83.7729C74.493 81.552 77.619 81.2292 78.2388 83.3685L78.2931 83.5559L79.0402 86.4266C79.5849 88.5197 82.6027 88.3786 82.9498 86.2438L84.3535 77.6093C84.4778 76.8443 85.033 76.22 85.7782 76.0071L86.1779 75.893C87.0664 75.6392 88.0131 76.0271 88.4681 76.8314L90.8215 80.992L93.8554 87.3943C93.9186 87.5277 93.9668 87.6676 93.9992 87.8115L95.1462 92.9061C95.6141 94.9843 98.5741 94.9881 99.0474 92.9111L100.18 87.939C100.203 87.8385 100.234 87.74 100.272 87.6443L102.238 82.7005C102.766 81.3718 104.477 81.0107 105.498 82.0126L106.072 82.5771C106.338 82.8381 106.526 83.1682 106.614 83.53L109.614 95.831L112.743 104.963L115.878 114.463L116.964 118.667C117.487 120.693 120.377 120.656 120.849 118.617L122.142 113.023L125.271 99.8525L128.367 85.7294C128.389 85.6269 128.403 85.5228 128.41 85.4181L131.516 32.328C131.529 32.1088 131.578 31.8931 131.661 31.6898L132.567 29.4682C133.218 27.8697 135.538 28.0522 135.932 29.733L136.391 31.6925C136.719 33.0919 138.723 33.0577 139.003 31.648V31.648C139.306 30.1208 141.533 30.2585 141.646 31.8114L144.033 64.6202C144.053 64.9013 144.133 65.1749 144.267 65.4231L147.075 70.6394C147.153 70.7855 147.213 70.9407 147.254 71.1016L150.148 82.6598C150.264 83.1231 150.55 83.5258 150.949 83.788V83.788C152.115 84.5538 153.682 83.8455 153.877 82.464L156.586 63.3081L159.488 52.5158C159.636 51.9636 160.014 51.5014 160.526 51.2459L161.159 50.9293C162.108 50.4553 163.262 50.8046 163.789 51.7252L165.66 54.9945C165.871 55.3643 166.196 55.6568 166.585 55.8295L168.74 56.7849C168.987 56.8945 169.21 57.0532 169.394 57.2513L170.107 58.0181C171.104 59.0909 172.879 58.7626 173.426 57.404L175.091 53.274C175.276 52.8149 175.625 52.4408 176.07 52.2239L177.747 51.4066C178.237 51.1679 178.608 50.7397 178.775 50.2211L178.934 49.7273C179.586 47.6985 182.537 47.9613 182.82 50.0735L184.75 64.4474C184.769 64.5889 184.803 64.728 184.851 64.8623L187.566 72.358C187.781 72.951 188.263 73.408 188.866 73.591L189.037 73.6427C190.127 73.973 191.272 73.328 191.554 72.2249L194.171 62.0086L197.248 50.7516C197.283 50.6234 197.33 50.499 197.39 50.3803L200.436 44.3247L201.946 40.3222C202.454 38.9769 204.388 39.0697 204.764 40.4575V40.4575C205.188 42.0206 207.453 41.8686 207.665 40.2629L209.829 23.831L212.589 3.46547C212.734 2.4001 214.072 2.00896 214.767 2.82876V2.82876C215.371 3.53993 216.513 3.35714 216.865 2.49322L217.081 1.96143C217.687 0.471806 219.869 0.720335 220.124 2.3081L221.792 12.6765C222.035 14.1912 223.861 14.8334 224.999 13.8048V13.8048C225.315 13.5194 225.528 13.1378 225.605 12.7191L226.895 5.70278C227.286 3.57256 230.312 3.49792 230.809 5.60623L231.219 7.34958C231.499 8.53858 232.77 9.20118 233.905 8.7498L234.711 8.429C234.827 8.38298 234.938 8.32625 235.044 8.25955L236.145 7.56115C237.145 6.92668 238.475 7.29601 239.005 8.35557L240.586 11.5183C240.931 12.2067 241.639 12.6365 242.409 12.6235L242.922 12.6149C243.741 12.6011 244.486 13.0884 244.801 13.8446L247.215 19.6307C247.345 19.9438 247.553 20.2186 247.82 20.4291L249.906 22.08C250.314 22.4033 250.58 22.8733 250.648 23.39L253.672 46.6076L256.46 69.7074C256.574 70.6531 257.818 70.9233 258.314 70.1101V70.1101C258.822 69.2779 260.099 69.5847 260.173 70.5568L262.44 100.284C262.594 102.306 265.377 102.727 266.122 100.841V100.841C266.174 100.709 266.211 100.572 266.233 100.432L269.205 81.3186C269.288 80.7903 269.606 80.3281 270.07 80.0625V80.0625C271.186 79.4235 272.588 80.1596 272.696 81.4413L275.536 115.168C275.577 115.653 275.793 116.107 276.144 116.444L278.309 118.521C278.583 118.784 278.926 118.964 279.298 119.039L280.351 119.252C281.205 119.424 282.049 118.918 282.3 118.084V118.084C282.841 116.285 285.476 116.585 285.597 118.461L286.979 139.797C287.133 142.174 290.568 142.339 290.949 139.987L291.113 138.975C291.204 138.408 291.541 137.904 292.027 137.599V137.599C293.182 136.873 294.722 137.481 295.048 138.805L297.053 146.946C297.274 147.844 298.343 148.22 299.078 147.659V147.659C299.817 147.095 300.892 147.479 301.106 148.384L303.706 159.365C303.759 159.587 303.849 159.798 303.972 159.989L305.78 162.789C306.398 163.747 307.69 163.995 308.619 163.334L309.467 162.731C309.844 162.463 310.116 162.073 310.237 161.627L311.964 155.289C312.308 154.026 314.095 154.013 314.458 155.27V155.27C314.853 156.639 316.845 156.461 316.991 155.044L319.443 131.216L322.402 118.559C322.512 118.092 322.785 117.68 323.173 117.397L325.581 115.644C325.665 115.583 325.744 115.515 325.816 115.442V115.442C326.986 114.26 329.001 115.016 329.106 116.675L331.576 155.859C331.649 157.017 333.288 157.179 333.587 156.058V156.058C333.882 154.949 335.499 155.092 335.596 156.235L338.218 187.255C338.229 187.394 338.256 187.532 338.296 187.665L339.191 190.624C339.785 192.585 342.593 192.492 343.054 190.495L344.493 184.268L347.629 165.127L350.18 150.06C350.374 148.915 351.897 148.644 352.474 149.652V149.652C353.012 150.592 354.413 150.436 354.73 149.4L357.022 141.929L360.157 129.759L362.012 120.744C362.405 118.831 365.027 118.559 365.805 120.35L366.421 121.769L369.492 130.955C369.531 131.07 369.559 131.189 369.576 131.31L372.453 151.745C372.583 152.67 373.415 153.33 374.345 153.247V153.247C375.194 153.171 375.865 152.495 375.936 151.645L378.943 115.236L380.463 105.926C380.815 103.767 383.88 103.66 384.383 105.789L385.154 109.058C385.19 109.207 385.242 109.352 385.31 109.489L388.343 115.587L388.699 116.268C389.588 117.971 392.133 117.563 392.445 115.667L393.049 111.996C393.402 109.857 396.429 109.728 396.962 111.83L397.736 114.885L399.166 119.828C399.704 121.687 402.306 121.774 402.967 119.956L404 117.115"
                    stroke="#00B4A0"
                  />
                </svg>
              </span>
              <span className={styles.bg_chart}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"40.4vh"}
                  height={"23.7vh"}
                  viewBox="0 0 404 237"
                  fill="none"
                >
                  <path
                    opacity="0.2"
                    d="M0 166.071L3.12895 156.957L6.26418 157.343L9.39316 142.68L12.5284 154.252L15.6574 153.111L18.7926 153.041L21.9216 161.997L25.0568 149.599L28.1857 131.652L31.3147 139.993L34.4499 149.88L37.5789 143.523L40.7142 146.965L43.8431 131.107L46.9784 131.16L50.1073 147.492L53.2425 131.845L56.3715 151.583L59.5067 143.997L62.6357 124.592L65.7647 120.096L68.8999 112.633L72.0289 117.849L75.1641 76.7559L78.2931 87.5559L81.4283 99.6027L84.5572 80.3559L87.6926 79.4603L90.8215 84.992L93.9504 91.5949L97.0857 105.521L100.215 91.7881L103.35 83.9032L106.479 86.9764L109.614 99.831L112.743 108.963L115.878 118.463L119.007 130.58L122.142 117.023L125.271 103.852L128.4 89.5754L131.536 35.9969L134.665 28.3227L137.8 41.7042L140.929 25.952L144.064 69.0466L147.193 74.8593L150.328 87.3803L153.457 89.4349L156.586 67.3081L159.721 55.6476L162.85 54.0847L165.986 59.5637L169.115 60.951L172.25 64.3227L175.379 56.5608L178.514 55.033L181.643 45.3042L184.778 68.6603L187.907 77.3003L191.036 78.2486L194.171 66.0086L197.3 54.5588L200.436 48.3247L203.564 40.0359L206.7 51.591L209.829 27.831L212.964 4.70323L216.093 8.39104L219.222 0.699332L222.357 20.192L225.486 17.3647L228.621 0.312988L231.75 13.6066L234.885 12.3598L238.014 10.3754L241.15 16.6447L244.279 16.592L247.414 24.1081L250.543 26.5842L253.672 50.6076L256.807 76.5803L259.936 71.4525L263.071 112.563L266.2 104.643L269.335 84.4827L272.464 82.6915L275.6 119.921L278.729 122.924L281.858 123.556L284.993 113.125L288.122 161.452L291.257 142.083L294.386 140.116L297.521 152.848L300.65 150.459L303.785 163.7L306.914 168.547L310.05 166.317L313.179 154.832L316.307 165.685L319.443 135.216L322.572 121.835L325.707 119.552L328.836 116.391L331.971 166.124L335.1 154.375L338.235 191.464L341.364 201.808L344.493 188.268L347.629 169.127L350.757 150.652L353.893 156.132L357.022 145.929L360.157 133.759L363.286 118.551L366.421 125.769L369.55 135.129L372.685 157.396L375.814 157.115L378.943 119.236L382.078 100.024L385.207 113.283L388.343 119.587L391.472 125.575L394.607 106.539L397.736 118.885L400.871 129.72L404 121.115V237H0V166.071Z"
                    fill="url(#paint0_linear_203_12552)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_203_12552"
                      x1="202"
                      y1="0.312988"
                      x2="202"
                      y2="237"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00B4A0" stop-opacity="0.4" />
                      <stop offset="1" stop-color="#00B4A0" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span className={styles.bg_circle}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="197"
                  height="197"
                  viewBox="0 0 197 197"
                  fill="none"
                >
                  <g opacity="0.16" filter="url(#filter0_f_203_12561)">
                    <path
                      d="M100 197C100 184.262 102.509 171.648 107.384 159.88C112.258 148.111 119.403 137.418 128.411 128.411C137.418 119.403 148.111 112.258 159.88 107.384C171.648 102.509 184.262 100 197 100V197H100Z"
                      fill="#00B4A0"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_203_12561"
                      x="0"
                      y="0"
                      width="297"
                      height="297"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="50"
                        result="effect1_foregroundBlur_203_12561"
                      />
                    </filter>
                  </defs>
                </svg>
              </span>
            </div>
            {
              account && account.AccountType !== AccountTypeEnum.Fake?
            <div className={styles.info_buttons}>
              {/* <Link to="/cabinet/deposit">
                {t("Deposit")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2218_591)">
                    <path
                      d="M13.3333 13.3333V9.33331M13.3333 9.33331L14.6667 10.6666M13.3333 9.33331L12 10.6666"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.3333 8.00002C15.3333 5.48586 15.3333 4.22878 14.5523 3.44774C13.7712 2.66669 12.5142 2.66669 10 2.66669H7.33333C4.81918 2.66669 3.5621 2.66669 2.78105 3.44774C2 4.22878 2 5.48586 2 8.00002C2 10.5142 2 11.7713 2.78105 12.5523C3.5621 13.3334 4.81918 13.3334 7.33333 13.3334H10"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7.33335 10.6667H4.66669"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M9.33333 10.6667H9"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M2 6.66669L15.3333 6.66669"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2218_591">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.666687)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Link> */}
              <button onClick={handleSetDrawerDeposit}>
                {t("Deposit")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2218_591)">
                    <path
                      d="M13.3333 13.3333V9.33331M13.3333 9.33331L14.6667 10.6666M13.3333 9.33331L12 10.6666"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.3333 8.00002C15.3333 5.48586 15.3333 4.22878 14.5523 3.44774C13.7712 2.66669 12.5142 2.66669 10 2.66669H7.33333C4.81918 2.66669 3.5621 2.66669 2.78105 3.44774C2 4.22878 2 5.48586 2 8.00002C2 10.5142 2 11.7713 2.78105 12.5523C3.5621 13.3334 4.81918 13.3334 7.33333 13.3334H10"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7.33335 10.6667H4.66669"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M9.33333 10.6667H9"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M2 6.66669L15.3333 6.66669"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2218_591">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.666687)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              {/* <Link to="/cabinet/withdrawal">
                {t("Withdraw")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M13.1666 9.33331V13.3333M13.1666 13.3333L14.5 12M13.1666 13.3333L11.8333 12"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.1666 8.00002C15.1666 5.48586 15.1666 4.22878 14.3856 3.44774C13.6045 2.66669 12.3475 2.66669 9.83331 2.66669H7.16665C4.65249 2.66669 3.39541 2.66669 2.61436 3.44774C1.83331 4.22878 1.83331 5.48586 1.83331 8.00002C1.83331 10.5142 1.83331 11.7713 2.61436 12.5523C3.39541 13.3334 4.65249 13.3334 7.16665 13.3334H9.83331"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M7.16667 10.6667H4.5"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9.16665 10.6667H8.83331"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1.83331 6.66669L15.1666 6.66669"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </Link> */}
              <button onClick={handleSetDrawerWithdrawal}>
                {t("Withdraw")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M13.1666 9.33331V13.3333M13.1666 13.3333L14.5 12M13.1666 13.3333L11.8333 12"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.1666 8.00002C15.1666 5.48586 15.1666 4.22878 14.3856 3.44774C13.6045 2.66669 12.3475 2.66669 9.83331 2.66669H7.16665C4.65249 2.66669 3.39541 2.66669 2.61436 3.44774C1.83331 4.22878 1.83331 5.48586 1.83331 8.00002C1.83331 10.5142 1.83331 11.7713 2.61436 12.5523C3.39541 13.3334 4.65249 13.3334 7.16665 13.3334H9.83331"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M7.16667 10.6667H4.5"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9.16665 10.6667H8.83331"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1.83331 6.66669L15.1666 6.66669"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
              :""
            }
          </div>
          <div className={styles.accounts}>
            <div className={styles.accounts_title}>
              <div className={styles.left_account_title}>
                <p>{t("Accounts")}</p>
                <span>{t("Descriptions")}</span>
              </div>
              <div
                className={styles.right_account_title}
                onClick={toggleDrawer(true)}
              >
                {t("Open new account")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"1.6vh"}
                  height={"1.6vh"}
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_312_2854)">
                    <circle
                      cx="8.00016"
                      cy="8.00016"
                      r="6.66667"
                      stroke="#FCFCFC"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M10 8.00002L8 8.00002M8 8.00002L6 8.00002M8 8.00002L8 6M8 8.00002L8 10"
                      stroke="#FCFCFC"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_312_2854">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div className={styles.accounts_body}>
              {accounts?.map((el, index) => (
                <div
                  key={index}
                  className={`${styles.account_block} ${
                    el.AccountType === AccountTypeEnum.Fake ? styles.demo_bg : ""
                  }`}
                >
                  <div className={styles.top_block}>
                    <div className={styles.currency}>
                      <div className={styles.currency_left}>
                        {el.AccountCurrency === "USD" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                          >
                            <path
                              d="M15.7573 31.0404C24.1025 31.0404 30.8161 24.3268 30.8161 15.9816C30.8161 7.63647 24.1025 0.922791 15.7573 0.922791C7.41216 0.922791 0.698486 7.63647 0.698486 15.9816C0.698486 24.3268 7.41216 31.0404 15.7573 31.0404Z"
                              fill="#00B4A0"
                            />
                            <path
                              d="M19.8985 18.3657C19.8985 16.1697 18.5809 15.4167 15.9456 15.103C14.0633 14.852 13.6868 14.3501 13.6868 13.4716C13.6868 12.593 14.3143 12.0285 15.5692 12.0285C16.6986 12.0285 17.3261 12.4049 17.6397 13.3461C17.7025 13.5344 17.8908 13.6598 18.079 13.6598H19.0828C19.3338 13.6598 19.5221 13.4716 19.5221 13.2207V13.1579C19.271 11.7774 18.1416 10.7108 16.6986 10.5854V9.07949C16.6986 8.82845 16.5103 8.64022 16.1967 8.57742H15.2555C15.0045 8.57742 14.8162 8.76566 14.7534 9.07949V10.5226C12.8711 10.7736 11.6791 12.0285 11.6791 13.5972C11.6791 15.6677 12.9339 16.4833 15.5692 16.7972C17.3261 17.1108 17.8908 17.4873 17.8908 18.4913C17.8908 19.4953 17.0122 20.1854 15.8202 20.1854C14.1887 20.1854 13.624 19.4951 13.4358 18.5539C13.3732 18.3031 13.1849 18.1775 12.9967 18.1775H11.93C11.6791 18.1775 11.4908 18.3657 11.4908 18.6167V18.6795C11.7417 20.2481 12.7457 21.3775 14.8162 21.6913V23.1972C14.8162 23.4481 15.0045 23.6363 15.3181 23.6991H16.2593C16.5103 23.6991 16.6986 23.5109 16.7614 23.1972V21.6913C18.6437 21.3775 19.8985 20.0598 19.8985 18.3657Z"
                              fill="white"
                            />
                            <path
                              d="M12.5588 24.9543C7.66472 23.1975 5.15486 17.7387 6.97457 12.9072C7.91575 10.2719 9.98634 8.26415 12.5588 7.32298C12.8099 7.19754 12.9353 7.0093 12.9353 6.69548V5.8171C12.9353 5.56607 12.8099 5.37783 12.5588 5.31519C12.496 5.31519 12.3706 5.31519 12.3078 5.37783C6.34707 7.26018 3.08427 13.5975 4.96663 19.5583C6.09604 23.0719 8.79413 25.77 12.3078 26.8995C12.5588 27.0249 12.8099 26.8995 12.8725 26.6484C12.9353 26.5858 12.9353 26.523 12.9353 26.3975V25.519C12.9353 25.3308 12.7471 25.0799 12.5588 24.9543ZM19.2099 5.37783C18.9588 5.25239 18.7078 5.37783 18.6452 5.62886C18.5824 5.69166 18.5824 5.7543 18.5824 5.87989V6.75827C18.5824 7.0093 18.7706 7.26018 18.9588 7.38577C23.853 9.14254 26.3628 14.6014 24.5431 19.4328C23.6019 22.0681 21.5313 24.0759 18.9588 25.0171C18.7078 25.1425 18.5824 25.3308 18.5824 25.6446V26.523C18.5824 26.774 18.7078 26.9622 18.9588 27.0249C19.0216 27.0249 19.1471 27.0249 19.2099 26.9622C25.1706 25.0799 28.4334 18.7425 26.551 12.7818C25.4216 9.20533 22.6607 6.50724 19.2099 5.37783Z"
                              fill="white"
                            />
                          </svg>
                        ) : (
                          <svg
                            viewBox="0 0 32 32"
                            width={"3.2vh"}
                            height={"3.2vh"}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000000"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <g fill="none" fill-rule="evenodd">
                                {" "}
                                <circle
                                  cx="16"
                                  cy="16"
                                  fill="#0f8ff8"
                                  r="16"
                                ></circle>{" "}
                                <path
                                  d="M8 19.004L8.81 17h.857a16.279 16.279 0 01-.034-1.03c0-.448.019-.864.056-1.25H8l.81-2.003h1.274C11.27 8.906 13.944 7 18.103 7c1.367 0 2.666.177 3.897.532v2.524a8.92 8.92 0 00-3.683-.776c-2.493 0-4.096 1.146-4.81 3.438h7.423l-.81 2.003h-7.097a6.938 6.938 0 00-.056.995c0 .479.015.907.045 1.285h6.183l-.8 2.003H13.44c.533 1.389 1.183 2.355 1.949 2.9.765.544 1.858.816 3.277.816 1.014 0 2.125-.247 3.334-.741v2.373c-1.149.432-2.515.648-4.1.648-4.167 0-6.803-1.999-7.906-5.996z"
                                  fill="#ffffff"
                                ></path>{" "}
                              </g>{" "}
                            </g>
                          </svg>
                        )}
                        {el.AccountCurrency}
                      </div>
                      <div className={styles.currency_right}>
                        <FormControlLabel
                          sx={{
                            margin: 0,
                            "& .MuiSwitch-root": {
                              margin: 0,
                              borderRadius: "4px",
                            },
                            "& .MuiSwitch-track": {
                              borderRadius: "4px",
                              backgroundColor:
                                "var(--background-3, #28282D) !important", // Цвет трека для неактивного состояния
                            },
                            "& .MuiSwitch-thumb": {
                              borderRadius: "2px",
                              backgroundColor:
                                "var(--border-3, #51525C) !important", // Цвет thumb для неактивного состояния
                            },
                            "& .Mui-checked + .MuiSwitch-track": {
                              borderRadius: "4px",
                              backgroundColor:
                                "var(--brand-mine, #3B82F6) !important", // Цвет трека для активного состояния
                            },
                            "& .Mui-checked .MuiSwitch-thumb": {
                              borderRadius: "2px",
                              backgroundColor:
                                "var(--text-mine, #FFF) !important", // Цвет thumb для активного состояния
                            },
                          }}
                          control={
                            <IOSSwitch
                              sx={{
                                m: 1,
                                "& .MuiSwitch-track": {
                                  borderRadius: "2px",
                                  backgroundColor:
                                    "var(--background-3, #28282D) !important", // Цвет для неактивного трека
                                },
                                "& .Mui-checked + .MuiSwitch-track": {
                                  borderRadius: "2px",
                                  backgroundColor:
                                    "var(--brand-mine, #3B82F6) !important", // Цвет для активного трека
                                },
                                "& .MuiSwitch-thumb": {
                                  borderRadius: "2px",
                                  backgroundColor:
                                    "var(--border-3, #51525C) !important", // Цвет thumb для неактивного состояния
                                },
                                "& .Mui-checked .MuiSwitch-thumb": {
                                  borderRadius: "2px",
                                  backgroundColor:
                                    "var(--text-mine, #FFF) !important", // Цвет thumb для активного состояния
                                },
                              }}
                              checked={el?.Id == account?.Id}
                              onClick={() => {
                                setAccount(el);
                                secureLocalStorage.setItem(
                                  "selected_account",
                                  el
                                );
                              }}
                            />
                          }
                        />
                      </div>
                    </div>
                    <div className={styles.balance}>
                      <p>{t("Balance")}:</p>
                      <h1>
                        {Math.trunc(
                          (el.AccountBalance +
                            (applications?.balances?.find(
                              (val) => val?.PlatformId == el?.Id
                            )?.TotalSum
                              ? applications?.balances?.find(
                                  (val) => val?.PlatformId == el?.Id
                                )?.TotalSum
                              : 0)) *
                            (el.AccountCurrency == "EUR" ? eurToUsd : 1) *
                            100
                        ) / 100}{" "}
                        {el.AccountCurrency}
                      </h1>
                    </div>
                  </div>
                  <div className={styles.bottom_block}>
                    <div className={styles.account_name}>{el.AccountTitle}</div>
                    <div
                      className={`${styles.type} ${
                        el.AccountType === AccountTypeEnum.Fake ? styles.demo : ""
                      }`}
                    >
                      {el.AccountType === AccountTypeEnum.Fake ? "Demo" : "Real"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.transactions}>
          <div className={styles.transaction_header}>
            <h3>{t("Transactions")}</h3>
            <div className={styles.tabs}></div>
          </div>
          <Table data={transactions} columns={columns} theme={theme} />
        </div>
        <div className={styles.mobile_transactions}>
          <div className={styles.label}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={"16px"}
              height={"16px"}
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M6.66659 2.66699H9.33325C11.8474 2.66699 13.1045 2.66699 13.8855 3.44804C14.4479 4.0104 14.6054 4.81954 14.6494 6.16699H1.3504C1.39448 4.81954 1.55194 4.0104 2.1143 3.44804C2.89535 2.66699 4.15243 2.66699 6.66659 2.66699Z"
                fill="#FCFCFC"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.6663 8.54534L14.3939 8.273C13.8081 7.68721 12.8584 7.68721 12.2726 8.273L11.7383 8.80729C11.5251 8.23851 10.9765 7.83366 10.3333 7.83366C9.50483 7.83366 8.83325 8.50523 8.83325 9.33366V10.5096C8.50665 10.5459 8.18969 10.6892 7.93926 10.9397C7.35347 11.5255 7.35347 12.4752 7.93926 13.061L8.21193 13.3337H6.66659C4.15243 13.3337 2.89535 13.3337 2.1143 12.5526C1.33325 11.7716 1.33325 10.5145 1.33325 8.00033C1.33325 7.7057 1.33325 7.42835 1.33451 7.16699H14.6653C14.6666 7.42835 14.6666 7.7057 14.6666 8.00033C14.6666 8.18896 14.6666 8.37053 14.6663 8.54534ZM3.99992 10.167C3.72378 10.167 3.49992 10.3908 3.49992 10.667C3.49992 10.9431 3.72378 11.167 3.99992 11.167H6.66659C6.94273 11.167 7.16659 10.9431 7.16659 10.667C7.16659 10.3908 6.94273 10.167 6.66659 10.167H3.99992Z"
                fill="#FCFCFC"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.3333 8.83366C10.6094 8.83366 10.8333 9.05752 10.8333 9.33366V12.1266L11.313 11.6468C11.5083 11.4515 11.8249 11.4515 12.0201 11.6468C12.2154 11.842 12.2154 12.1586 12.0201 12.3539L10.6868 13.6872C10.4915 13.8825 10.175 13.8825 9.9797 13.6872L8.64637 12.3539C8.4511 12.1586 8.4511 11.842 8.64637 11.6468C8.84163 11.4515 9.15821 11.4515 9.35347 11.6468L9.83325 12.1266V9.33366C9.83325 9.05752 10.0571 8.83366 10.3333 8.83366ZM12.9797 8.98011C13.175 8.78484 13.4915 8.78484 13.6868 8.98011L15.0201 10.3134C15.2154 10.5087 15.2154 10.8253 15.0201 11.0205C14.8249 11.2158 14.5083 11.2158 14.313 11.0205L13.8333 10.5408V13.3337C13.8333 13.6098 13.6094 13.8337 13.3333 13.8337C13.0571 13.8337 12.8333 13.6098 12.8333 13.3337V10.5408L12.3535 11.0205C12.1582 11.2158 11.8416 11.2158 11.6464 11.0205C11.4511 10.8253 11.4511 10.5087 11.6464 10.3134L12.9797 8.98011Z"
                fill="#FCFCFC"
              />
            </svg>
            {t("Transactions")}
          </div>
          <div className={styles.transactions_list}>
            {transactions.map((el) => (
              <div className={styles.transaction} key={el.Id}>
                <div className={styles.type_status}>
                  <div
                    className={`${styles.type} ${
                      el.Type === "Withdrawal" ? styles.with : ""
                    }`}
                  >
                    {el.Type === "Withdrawal" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                      >
                        <path
                          d="M13.3812 9.33301V13.333M13.3812 13.333L14.7145 11.9997M13.3812 13.333L12.0479 11.9997"
                          stroke="#E9770E"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.3809 8.00033C15.3809 5.48617 15.3809 4.22909 14.5999 3.44804C13.8188 2.66699 12.5618 2.66699 10.0476 2.66699H7.38094C4.86678 2.66699 3.6097 2.66699 2.82866 3.44804C2.04761 4.22909 2.04761 5.48617 2.04761 8.00033C2.04761 10.5145 2.04761 11.7716 2.82866 12.5526C3.6097 13.3337 4.86678 13.3337 7.38094 13.3337H10.0476"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                        <path
                          d="M7.38102 10.667H4.71436"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                        <path
                          d="M9.38119 10.667H9.04785"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                        <path
                          d="M2.04761 6.66699L15.3809 6.66699"
                          stroke="#E9770E"
                          stroke-linecap="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                      >
                        <path
                          d="M13.3812 13.333V9.33301M13.3812 9.33301L14.7145 10.6663M13.3812 9.33301L12.0479 10.6663"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.3809 8.00033C15.3809 5.48617 15.3809 4.22909 14.5999 3.44804C13.8188 2.66699 12.5618 2.66699 10.0476 2.66699H7.38094C4.86678 2.66699 3.6097 2.66699 2.82866 3.44804C2.04761 4.22909 2.04761 5.48617 2.04761 8.00033C2.04761 10.5145 2.04761 11.7716 2.82866 12.5526C3.6097 13.3337 4.86678 13.3337 7.38094 13.3337H10.0476"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                        <path
                          d="M7.38102 10.667H4.71436"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                        <path
                          d="M9.38119 10.667H9.04785"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                        <path
                          d="M2.04761 6.66699L15.3809 6.66699"
                          stroke="#00B4A0"
                          stroke-linecap="round"
                        />
                      </svg>
                    )}
                    {el.Type}
                  </div>
                  <div className={styles.status}>
                    {el?.ApplicationId
                      ? ["Submitted", "Expectation"].includes(el?.Status)
                        ? "Pending"
                        : t("Completed")
                      : t("Completed")}
                  </div>
                </div>
                <div className={styles.account_amount}>
                  <div className={styles.account}>
                    <label htmlFor="">{t("Account")}</label>
                    <p>{el.PlatformId}</p>
                  </div>
                  <div className={styles.amount}>
                    <label htmlFor="">{t("Amount")}</label>
                    <p
                      className={`${
                        el.Type === "Withdrawal" ? styles.with : ""
                      }`}
                    >
                      {account?.AccountCurrency == "USD" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_575_44989)">
                            <path
                              d="M7.87878 15.5202C12.0514 15.5202 15.4082 12.1634 15.4082 7.99084C15.4082 3.81826 12.0514 0.461426 7.87878 0.461426C3.7062 0.461426 0.349365 3.81826 0.349365 7.99084C0.349365 12.1634 3.7062 15.5202 7.87878 15.5202Z"
                              fill="#00B4A0"
                            />
                            <path
                              d="M9.9492 9.18271C9.9492 8.08469 9.29039 7.70822 7.97276 7.55138C7.03159 7.42587 6.84336 7.17491 6.84336 6.73564C6.84336 6.29638 7.15711 6.0141 7.78452 6.0141C8.34922 6.0141 8.66297 6.20233 8.8198 6.67292C8.8512 6.76704 8.94532 6.82976 9.03943 6.82976H9.54134C9.66685 6.82976 9.76097 6.73564 9.76097 6.6102V6.5788C9.63545 5.88858 9.07076 5.35527 8.34922 5.29255V4.53961C8.34922 4.41409 8.25511 4.31997 8.09827 4.28857H7.62769C7.50217 4.28857 7.40806 4.38269 7.37666 4.53961V5.26115C6.4355 5.38667 5.83948 6.0141 5.83948 6.79844C5.83948 7.83374 6.4669 8.24153 7.78452 8.39844C8.66297 8.55528 8.94532 8.74352 8.94532 9.24551C8.94532 9.74749 8.50606 10.0926 7.91004 10.0926C7.09431 10.0926 6.81196 9.74742 6.71785 9.27683C6.68653 9.15139 6.59241 9.08859 6.49829 9.08859H5.96492C5.83948 9.08859 5.74536 9.18271 5.74536 9.30823V9.33962C5.8708 10.1239 6.37278 10.6886 7.40806 10.8455V11.5985C7.40806 11.7239 7.50218 11.818 7.65901 11.8494H8.12959C8.25511 11.8494 8.34922 11.7553 8.38062 11.5985V10.8455C9.32178 10.6886 9.9492 10.0298 9.9492 9.18271Z"
                              fill="white"
                            />
                            <path
                              d="M6.27942 12.4773C3.83236 11.5989 2.57743 8.86948 3.48729 6.45374C3.95787 5.1361 4.99317 4.1322 6.27942 3.66161C6.40493 3.59889 6.46765 3.50477 6.46765 3.34786V2.90867C6.46765 2.78315 6.40493 2.68904 6.27942 2.65771C6.24802 2.65771 6.1853 2.65771 6.1539 2.68904C3.17354 3.63021 1.54214 6.79889 2.48331 9.77926C3.04802 11.5361 4.39706 12.8851 6.1539 13.4498C6.27942 13.5126 6.40493 13.4498 6.43626 13.3243C6.46765 13.293 6.46765 13.2616 6.46765 13.1989V12.7596C6.46765 12.6655 6.37354 12.5401 6.27942 12.4773ZM9.60493 2.68904C9.47942 2.62632 9.3539 2.68904 9.32258 2.81455C9.29118 2.84595 9.29118 2.87727 9.29118 2.94007V3.37926C9.29118 3.50477 9.3853 3.63021 9.47942 3.69301C11.9265 4.57139 13.1814 7.3008 12.2715 9.71654C11.801 11.0342 10.7657 12.0381 9.47942 12.5087C9.3539 12.5714 9.29118 12.6655 9.29118 12.8224V13.2616C9.29118 13.3871 9.3539 13.4812 9.47942 13.5126C9.51082 13.5126 9.57354 13.5126 9.60493 13.4812C12.5853 12.5401 14.2167 9.37139 13.2755 6.39102C12.7108 4.60279 11.3304 3.25374 9.60493 2.68904Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_575_44989">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          viewBox="0 0 32 32"
                          width="16"
                          height="16"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="#000000"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <g fill="none" fill-rule="evenodd">
                              {" "}
                              <circle
                                cx="16"
                                cy="16"
                                fill="#0f8ff8"
                                r="16"
                              ></circle>{" "}
                              <path
                                d="M8 19.004L8.81 17h.857a16.279 16.279 0 01-.034-1.03c0-.448.019-.864.056-1.25H8l.81-2.003h1.274C11.27 8.906 13.944 7 18.103 7c1.367 0 2.666.177 3.897.532v2.524a8.92 8.92 0 00-3.683-.776c-2.493 0-4.096 1.146-4.81 3.438h7.423l-.81 2.003h-7.097a6.938 6.938 0 00-.056.995c0 .479.015.907.045 1.285h6.183l-.8 2.003H13.44c.533 1.389 1.183 2.355 1.949 2.9.765.544 1.858.816 3.277.816 1.014 0 2.125-.247 3.334-.741v2.373c-1.149.432-2.515.648-4.1.648-4.167 0-6.803-1.999-7.906-5.996z"
                                fill="#ffffff"
                              ></path>{" "}
                            </g>{" "}
                          </g>
                        </svg>
                      )}
                      {el.Type === "Withdrawal" ? "-" : "+"}
                      {getSymbolByAccount()}
                      {parseFloat(
                        el.Sum *
                          (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      ).toFixed(1)}
                    </p>
                  </div>
                </div>
                <div className={styles.id_date}>
                  <div className={styles.id}>ID {el.Id}</div>
                  <div className={styles.date}>
                    {moment.utc(el.Date).local().format("YYYY-MM-DD HH:mm")}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <Box>
      <Box
        onClick={toggleChat}
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          backgroundColor: "#007bff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          cursor: "pointer",
        }}
      >
        <ChatIcon sx={{ color: "#fff", fontSize: "32px" }} />
      </Box>

      {isChatOpen && (
        <Box
          sx={{
            position: "fixed",
            bottom: "90px",
            right: "20px",
            width: "400px",
            height: "400px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            zIndex: "9999",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              padding: "10px",
              overflowY: "auto",
              backgroundColor: "#f9f9f9",
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
            }}
          >
            {chatHistory.map((message, index) => (
              <Box
                key={index}
                sx={{
                  textAlign: message.sender === "User" ? "right" : "left",
                  marginBottom: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "inline-block",
                    padding: "8px",
                    borderRadius: "10px",
                    backgroundColor: message.sender === "User" ? "#d1e7dd" : "#e2e3e5",
                    color: "#333",
                    fontSize: "14px",
                  }}
                >
                  {message.text}
                </Box>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              borderTop: "1px solid #ddd",
              padding: "10px",
              backgroundColor: "#fff",
            }}
          >
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Введите сообщение..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={sendMessage}
              sx={{ marginLeft: "10px" }}
            >
              Отправить
            </Button>
          </Box>
        </Box>
      )}
    </Box> */}
      <AddAccountDrawer open={open} toggleDrawer={toggleDrawer} theme={theme} AccountTypeEnum={AccountTypeEnum}  />
      <Drawer
        open={drawerWithdrawalIsOpen}
        anchor={window.innerWidth <= 600 ? "bottom" : "right"}
      >
        <Withdrawal
          AccountTypeEnum={AccountTypeEnum}
          getSymbolByAccount={getSymbolByAccount}
          getAssetNameByAccount={getAssetNameByAccount}
          eurToUsd={eurToUsd}
          usdToEur={usdToEur}
          account={account}
          setSnackMessage={setSnackMessage}
          setSnackType={setSnackType}
          handleClick={handleClick}
          handleSetDrawerWithdrawal={handleSetDrawerWithdrawal}
          theme={theme}
        />
      </Drawer>
      <Drawer
        open={drawerDepositIsOpen}
        anchor={window.innerWidth <= 600 ? "bottom" : "right"}
      >
        <Deposit
          AccountTypeEnum={AccountTypeEnum}
          getSymbolByAccount={getSymbolByAccount}
          getAssetNameByAccount={getAssetNameByAccount}
          theme={theme}
          eurToUsd={eurToUsd}
          usdToEur={usdToEur}
          account={account}
          setSnackMessage={setSnackMessage}
          setSnackType={setSnackType}
          handleClick={handleClick}
          handleSetDrawerDeposit={handleSetDrawerDeposit}
        />
      </Drawer>
    </div>
  );
}
